import type { ReactElement } from "react";
import styles from "./InspectorIconGlyph.module.css";

export interface InspectorIconGlyphProps {
  src: string;
  size: number;
  /** Optional hook for contextual tint (e.g. trash hover). */
  dataIcon?: string;
  className?: string;
}

/**
 * Tinted SVG via <img> + filter — reliable in production (CSS mask + data: URLs
 * can render as empty squares on mobile Safari).
 */
export function InspectorIconGlyph({
  src,
  size,
  dataIcon,
  className
}: InspectorIconGlyphProps): ReactElement {
  const classes = [styles.glyph, className ?? ""].filter(Boolean).join(" ");
  return (
    <img
      className={classes}
      src={src}
      alt=""
      width={size}
      height={size}
      data-icon={dataIcon}
      aria-hidden
    />
  );
}
